import React, { useEffect, useState } from 'react';

import { useTimeout } from '@paragon/client-tools';

// The startup actions will have spinners to cover data loading, so this timeout is set intentionally high because this
//   page will hopefully never trigger. It is intended to cover cases where some data that's needed to render the app
//   has silently failed to load.
const WAIT_TIME = 1000;

export function LoadingPage() {
  const [showSpinner, setShowSpinner] = useState(false);
  const setTimeout = useTimeout();

  useEffect(() => {
    setTimeout(() => {
      setShowSpinner(true);
    }, WAIT_TIME);
  }, [setTimeout]);

  return showSpinner ? <>Loading is taking longer than expected... If this persists, contact Paragon Support.</> : null;
}
